<template>
  <div class="case-digital-mlpa-main-data-page col-block width-full">
    <template v-if="stateOptions[project.state]">
      <div class="case-digital-mlpa-main-data-status-container col-block">
        <div class="case-digital-mlpa-main-data-status" :class="project.state" v-html="stateOptions[project.state].title"></div>
      </div>
    </template>
    <template v-else>
      <div class="case-digital-mlpa-main-data-main-container col-block width-full">
        <div class="case-digital-mlpa-main-data-main-info-container col-block width-full">
          <div class="case-digital-mlpa-main-data-main-info-title-container row-block" :class="{ display: display['info'] }" @click="e => display['info'] = !display['info']">
            <div class="case-digital-mlpa-main-data-main-info-title">{{ $t('COMPONENT.digitalMLPA.mainData.info.___title') }}</div>
            <img :src="require('../../assets/images/config-filter-display-icon.svg')" alt="">
          </div>
          <template v-if="display['info']">
            <div class="case-digital-mlpa-main-data-main-info-data-container col-block width-full">
              <mainDataInfo
                :project="project"
              ></mainDataInfo>
            </div>
          </template>
          <template v-else>
            <div :style="{ height: '4px' }"></div>
            <div class="case-digital-mlpa-main-data-main-info-result-field row-block flex-start flex-wrap">
              <div class="case-digital-mlpa-main-data-main-info-result-container col-block">
                <div class="case-digital-mlpa-main-data-main-info-result-block">
                  <div class="case-digital-mlpa-main-data-main-info-result-content-container">
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="case-digital-mlpa-main-data-main-panel-container col-block width-full">
          <div class="case-digital-mlpa-main-data-main-panel-option-container col-block width-full">
            <div class="case-digital-mlpa-main-data-main-panel-option-block row-block flex-start">
              <div
                class="case-digital-mlpa-main-data-main-panel-option-form-container row-block flex-start"
                v-for="(group, gindex) in [['panel', 'subpanel'], [form['subpanel'] ? 'segment' : '']]"
                :key="gindex"
                :style="{ flex: 1 }"
              >
                <div
                  class="case-digital-mlpa-main-data-main-panel-option-form-block col-block width-full"
                  v-for="key in group"
                  :key="key"
                  :style="{ flex: 1 }"
                >
                  <template v-if="key">
                    <div class="case-digital-mlpa-main-data-main-panel-option-form-data-title-container row-block">
                      <div class="case-digital-mlpa-main-data-main-panel-option-form-data-title">{{ formOptions[key].title }}</div>
                      <div :style="{ flex: 1 }"></div>
                    </div>
                    <div class="case-digital-mlpa-main-data-main-panel-option-form-data-content-container col-block width-full" :class="formOptions[key].type">
                      <template v-if="formOptions[key].type === 'select'">
                        <div class="case-digital-mlpa-main-data-main-panel-option-form-data-content-select-container col-block width-full">
                          <div class="case-digital-mlpa-main-data-main-panel-option-form-data-content-select-block input-group col-block width-full">
                            <select required v-model="form[formOptions[key].key]">
                              <option v-if="formOptions[key].placeholder" disabled hidden value="">{{ formOptions[key].placeholder }}</option>
                              <option v-for="(option, oindex) in formOptions[key].options || []" :key="oindex" :value="option.value">{{ option.title }}</option>
                            </select>
                          </div>
                        </div>
                      </template>
                      <template v-else-if="formOptions[key].type === 'data'">
                        <div class="case-digital-mlpa-main-data-main-panel-option-form-data-content-data-container col-block width-full">
                          <div class="case-digital-mlpa-main-data-main-panel-option-form-data-content-data-block">
                            <div
                              class="case-digital-mlpa-main-data-main-panel-option-form-data-content-data-text-block row-block"
                              v-for="(option, oindex) in formOptions[key].options || []"
                              :key="oindex"
                              :class="{ empty: !option.title }"
                            >
                              <template v-if="option.title">
                                <div class="case-digital-mlpa-main-data-main-panel-option-form-data-content-data-text-title shrink ellipsis">{{ option.title }}</div>
                                <div class="case-digital-mlpa-main-data-main-panel-option-form-data-content-data-text-content">{{ option.value }}</div>
                                <div :style="{ flex: 1 }"></div>
                              </template>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div v-if="form['subpanel']" :key="form['subpanel']" class="case-digital-mlpa-main-data-main-panel-data-container col-block width-full">
            <div v-if="currentSubpanel.chart_view" class="case-digital-mlpa-main-data-main-panel-chart-container col-block width-full" :style="{ height: '320px' }">
              <mainDataChart
                :panelData="currentSubpanel"
                :selectData="data['table']"
                @select="d => data['chart'] = d"
              ></mainDataChart>
            </div>
            <div v-if="currentSubpanel.fragment_table" class="case-digital-mlpa-main-data-main-panel-table-container col-block width-full" :style="{ height: '360px' }">
              <mainDataTable
                :panelData="currentSubpanel"
                :selectData="data['chart']"
                @select="d => data['table'] = d"
              ></mainDataTable>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import mainDataInfo from './mainDataInfo.vue'
import mainDataChart from './mainDataChart.vue'
import mainDataTable from './mainDataTable.vue'

export default {
  components: {
    mainDataInfo,
    mainDataChart,
    mainDataTable
  },
  props: {
    projects: {
      type: Array,
      required: true
    },
    projectID: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      data: {
        'table': null,
        'chart': null
      },
      form: {
        'panel': '',
        'subpanel': ''
      },
      display: {
        'info': true
      }
    }
  },
  computed: {
    project () {
      return this.projects.find(project => String(project.id) === this.projectID)
    },
    panelData () {
      return ((this.project.views || {}).ResultView || {}).panel || []
    },
    currentPanel () {
      return this.panelData.find(panel => this.form['panel'] === panel.panel_name) || {}
    },
    currentSubpanel () {
      return (this.currentPanel.subpanel || []).find(subpanel => this.form['subpanel'] === subpanel.subpanel_name) || {}
    },
    // static
    panelOptions () {
      let panelOptions = this.panelData.map(panel => ({ title: panel.panel_name, value: panel.panel_name }))
      this.form['panel'] = ''
      return panelOptions
    },
    subpanelOptions () {
      let subpanelOptions = (this.currentPanel.subpanel || []).map(subpanel => ({ title: subpanel.subpanel_name, value: subpanel.subpanel_name }))
      this.form['subpanel'] = (subpanelOptions[0] || {}).value || ''
      this.data = {
        'table': null,
        'chart': null
      }
      return subpanelOptions
    },
    segmentOptions () {
      let segmentData = {
        ...(this.currentSubpanel.segment_view || {}),
        ...((this.currentSubpanel.segment_view || {}).extensions || {})
      }
      let segmentOptions = [
        {
          title: this.$t('COMPONENT.digitalMLPA.mainData.form.Segment.data.title.___Aberrant_Count'),
          value: segmentData.aberrant_count
        },
        {
          title: this.$t('COMPONENT.digitalMLPA.mainData.form.Segment.data.title.___Mean'),
          value: segmentData.Mean
        },
        {
          title: this.$t('COMPONENT.digitalMLPA.mainData.form.Segment.data.title.___SD'),
          value: segmentData.StandardDeviation
        },
        {
          title: this.$t('COMPONENT.digitalMLPA.mainData.form.Segment.data.title.___Med'),
          value: segmentData.Median
        },
        {
          title: this.$t('COMPONENT.digitalMLPA.mainData.form.Segment.data.title.___Min'),
          value: segmentData.Minimum
        },
        {
          title: this.$t('COMPONENT.digitalMLPA.mainData.form.Segment.data.title.___Max'),
          value: segmentData.Maximum
        },
        {
          title: this.$t('COMPONENT.digitalMLPA.mainData.form.Segment.data.title.___Range'),
          value: segmentData.Range
        }
      ].filter(option => ![null, undefined].includes(option.value))
      if (segmentOptions.length > 4) {
        segmentOptions.splice(4, 0, {})
      }
      return segmentOptions
    },
    formOptions () {
      return {
        'panel': {
          title: this.$t('COMPONENT.digitalMLPA.mainData.form.Panel.___title'),
          type: 'select',
          key: 'panel',
          options: this.panelOptions,
          placeholder: this.$t('COMPONENT.digitalMLPA.mainData.form.Panel.___placeholder')
        },
        'subpanel': {
          title: this.$t('COMPONENT.digitalMLPA.mainData.form.Subpanel.___title'),
          type: 'select',
          key: 'subpanel',
          options: this.subpanelOptions,
          placeholder: this.$t('COMPONENT.digitalMLPA.mainData.form.Subpanel.___placeholder')
        },
        'segment': {
          title: this.$t('COMPONENT.digitalMLPA.mainData.form.Segment.___title'),
          type: 'data',
          options: this.segmentOptions
        }
      }
    },
    stateOptions () {
      return {
        'analyzing': {
          title: this.$t('COMPONENT.digitalMLPA.mainData.status.title.___analyzing')
        },
        'error': {
          title: this.$t('COMPONENT.digitalMLPA.mainData.status.title.___error')
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/digitalMLPA/mainData.vue